import { isOnPage } from './utils';

/**
 * Search info
 */
const elements = {
  sideA: null,
  sideB: null,
  minPrice: null,
};
const state = {
  sideA: {
    visible: false,
    value: null,
  },
  sideB: {
    visible: false,
    value: null,
  },
  minPrice: {
    visible: false,
    value: null,
  },
};
const render = (s) => {
  const toggleLoader = (el, visible = false) => {
    if (visible) {
      el.querySelector('.ajax-loader').classList.remove('ajax-loader--visible');
    } else {
      el.querySelector('.ajax-loader').classList.add('ajax-loader--visible');
    }
  };

  elements.sideA.querySelector('[data-value]').textContent = state.sideA.value;
  elements.sideB.querySelector('[data-value]').textContent = state.sideB.value;
  elements.minPrice.querySelector('[data-value]').textContent = state.minPrice.value;

  if (s.sideA.visible) {
    toggleLoader(elements.sideA, true);
  } else {
    toggleLoader(elements.sideA, false);
  }
  if (s.sideB.visible) {
    toggleLoader(elements.sideB, true);
  } else {
    toggleLoader(elements.sideB, false);
  }
  if (s.minPrice.visible) {
    toggleLoader(elements.minPrice, true);
  } else {
    toggleLoader(elements.minPrice, false);
  }
};

const init = () => {
  const container = document.querySelector('#search-info');
  const endpoint = `${window.location.origin}/wp-json/motion/v1/search-info`;
  const { searchParams } = (new URL(document.location));
  const searchParamsKeys = Array.from(searchParams.keys());
  const searchParamsPairs = searchParamsKeys.reduce((acc, key) => {
    if (searchParams.get(key) === '') {
      return acc;
    }
    const value = searchParams.getAll(key);
    acc[key] = (value.length > 1) ? value : value[0];

    return acc;
  }, {});
  searchParamsPairs.search_info = true;

  elements.sideA = container.querySelector('#search-info-side-a');
  elements.sideB = container.querySelector('#search-info-side-b');
  elements.minPrice = container.querySelector('#search-info-min-price');

  $.ajax({
    url: endpoint,
    data: searchParamsPairs,
    beforeSend() {
      state.sideA.value = '0';
      state.sideB.value = '0';
      state.minPrice.value = '0';
      state.sideA.visible = false;
      state.sideB.visible = false;
      state.minPrice.visible = false;
      render(state);
    },
    success(data) {
      state.sideA.value = data.side_a;
      state.sideB.value = data.side_b;
      state.minPrice.value = data.min_price;
      state.sideA.visible = true;
      state.sideB.visible = true;
      state.minPrice.visible = true;
      render(state);
    },
  });
};

if (isOnPage('#search-info')) {
  init();
}
